import request from "@/common/js/request.js";
/**
 * 根据id获取机构h5模板
 */
export function getH5ById(obj) {
  const url = "/h5Template/selectOneByMappingId";
  // console.log("obj" + JSON.stringify(obj));
  return request({
    url: url,
    method: "get",
    params: obj
  });
}

/**
 * 创建h5模板
 * @param {*} obj
 */
export function createH5(obj) {
  const url = "/h5Template/dynamicHtml";
  return request({
    url: url,
    method: "get",
    params: obj
  });
}
/**
 * 更新模板
 * @param {*} obj
 */
export function updateH5(obj) {
  const url = "/h5Template/updateH5Template";
  return request({
    url: url,
    method: "get",
    params: obj
  });
}



// WEBPACK FOOTER //
// ./src/api/h5Temp.js